
import { computed, defineComponent, onBeforeMount, reactive } from 'vue'
import { useRoute, useRouter } from 'vue-router'

// @components
import PageTitle from '@/common/components/UI/PageTitle/index.vue'
import Loader from '@/common/components/UI/Loader/index.vue'
import NewButton from '@/ui-kit/NewButton/index.vue'
import NewTable from '@/common/new-components/NewTable/index.vue'
import ButtonDropdown from '@/common/components/UI/ButtonDropdown/index.vue'

import RouteSheetInvoiceRow from '@/modules/NewDispatcher/components/RouteSheetInvoiceRow/index.vue'

// @types
import { RouteSheetDetails } from '@/new-services/types/route-sheet'

// @new-services
import routeSheetAPI from '@/new-services/route-sheet.service'

// @composable
import useNotifications from '@/common/composable/useNotifications'
import { useFile } from '@/common/composable/useFile'

const TABLE_COLUMNS = [
    {
        key: 'index',
        name: '№',
    },
    {
        key: 'invoiceNumber',
        name: 'Номер накладной',
    },
    {
        key: 'companyName',
        name: 'Клиент',
    },
    {
        key: 'deliveryStatus',
        name: 'Статус',
    },
    {
        key: 'waitListStatus',
        name: 'Статус ЛО',
    },
    {
        key: 'deliveredDate',
        name: 'Дата доставки факт',
    },
    {
        key: 'courierReturnDate',
        name: 'Возврат выдачи',
    },
    {
        key: 'cityName',
        name: 'Город, сектор',
    },
    {
        key: 'waveName',
        name: 'Волна',
    },
    {
        key: 'address',
        name: 'Адрес',
    },
    {
        key: 'callCenterComment',
        name: 'Комментарий',
    },
    {
        key: 'receiverName',
        name: 'Груз принял',
    },
    {
        key: 'places',
        name: 'Кол-во мест',
    },
    {
        key: 'weight',
        name: 'Физ вес',
    },
    {
        key: 'volumeWeight',
        name: 'Объемный вес',
    },
    {
        key: 'customerInvoiceNumber',
        name: 'Номер накладной заказчика',
    },
    {
        key: 'codPayment',
        name: 'Сумма наложенного платежа',
    },
    {
        key: 'cashSum',
        name: 'Сумма наличных',
    },
]

export default defineComponent({
    components: {
        PageTitle,
        Loader,
        NewButton,
        NewTable,
        RouteSheetInvoiceRow,
        ButtonDropdown,
    },
    setup() {
        const { saveFile } = useFile()
        const notifications = useNotifications()
        const route = useRoute()
        const router = useRouter()

        const routeSheetId = Number(route.params.id as string)

        const state = reactive({
            is_loading: false,
            is_failed: false,
            routeSheetDetails: null as RouteSheetDetails | null,
        })

        const report_state = reactive({
            is_loading: false,
        })

        const one_c_state = reactive({
            is_loading: false,
        })

        const loadRouteSheet = async () => {
            try {
                state.is_loading = true

                const response = await routeSheetAPI.getRouteSheetDetails(routeSheetId)
                state.routeSheetDetails = response.data.data

                state.is_failed = false
            } catch (error) {
                state.is_failed = true
                console.error(error)
                notifications.notifyError({
                    error,
                    title: 'При получении детальной информации о маршрутном листе произошла ошибка',
                })
            } finally {
                state.is_loading = false
            }
        }

        const downloadReport = async () => {
            if (!state.routeSheetDetails) return

            try {
                report_state.is_loading = true

                const response = await routeSheetAPI.downloadReport(routeSheetId)
                saveFile(response.data, `Отчет (${state.routeSheetDetails.number})`)
            } catch (error) {
                console.error(error)
                notifications.notifyError({ error, title: 'При выгрузке отчета произошла ошибка' })
            } finally {
                report_state.is_loading = false
            }
        }

        const resendOneC = async () => {
            try {
                one_c_state.is_loading = true

                await routeSheetAPI.resendOneC(routeSheetId)
                notifications.notify({ title: 'Успешно переотправлено!', type: 'success' })
            } catch (error) {
                console.error(error)
                notifications.notifyError({ error, title: 'При переотправке произошла ошибка' })
            } finally {
                one_c_state.is_loading = false
            }
        }

        onBeforeMount(loadRouteSheet)

        const onBack = () => {
            router.replace('/new-dispatcher/route-sheet')
        }

        const pageTitle = computed(() => {
            if (state.routeSheetDetails) {
                const { number, date, courier } = state.routeSheetDetails,
                    courier_name = courier ? courier.fullName : '...'

                return `Детализация маршрутного листа ${number} от ${date} - ${courier_name}`
            }

            return 'Детализация маршрутного листа ... от ... - ...'
        })

        const isResend = computed(() => {
            return (
                state.routeSheetDetails &&
                state.routeSheetDetails.invoices &&
                !state.routeSheetDetails.invoices.length
            )
        })

        return {
            TABLE_COLUMNS,
            state,
            report_state,
            one_c_state,
            downloadReport,
            loadRouteSheet,
            onBack,
            pageTitle,
            resendOneC,
            isResend,
        }
    },
})
